// extracted by mini-css-extract-plugin
module.exports = {"brandCard":"styles_brandCard__m5x4c"};